module.exports = __webpack_public_path__ + "0d808b90bc3c9eaa1288e8744bae21c1.png";